import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useObraItensChecklistAreaCadastroFilters
 */

type State = {
  data: Date | null;
  localizacao: string | null;
  status: number;
};

type Actions = {};

export const initialObraItensChecklistAreaCadastroFilters: State = {
  data: null,
  localizacao: "",
  status: 4,
};

export const useObraItensChecklistAreaCadastroFilters = create<State & Actions>((set) => ({
  ...initialObraItensChecklistAreaCadastroFilters,
}));